module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/35efc91659039e43f27f819a02a62632.png";